import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";
import { CreateGameDialog } from "../components/CreateGameDialog";

export function WelcomeView() {
  const { t } = useTranslation();
  const [createDialogOpen, setCreateDialogOpen] = React.useState(false);
  return (
    <Box
      marginX={"auto"}
      maxWidth={"600px"}
      p={2}
      display="flex"
      flexDirection={"column"}
      alignItems="center"
    >
      <Typography textAlign={"center"} variant="h6" mb={3}>
        AlleViere.de
      </Typography>

      <Typography textAlign={"center"} variant="overline">
        {t("welcomeTitle")}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t("welcomeText")}
      </Typography>
      <Button
        color="primary"
        variant="outlined"
        onClick={() => setCreateDialogOpen(true)}
      >
        {t("createYourFirstGame")}
      </Button>

      <CreateGameDialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        count={0}
      />
    </Box>
  );
}
